import { http } from "@/http/axios.js";

// 获取跟进记录列表
export function getFollowUpRecordListAPI(params) {
  return http({
    url: "/admin/order/follow/log/list",
    method: "get",
    params,
  });
}

// 添加跟进记录
export function addFollowUpRecordAPI(data) {
  return http({
    url: "/admin/order/follow/log/add",
    method: "post",
    data,
  });
}
